export default __webpack_public_path__ + "static/media/009-German Shepherd.a4883013.svg";